import { useEffect } from "react"
import { mapFiltersData } from "../helpers/mapFiltersData"
import { useTableContext } from "../provider"
import { IFetchArgs, LifecycleState } from "../types"

export const useDataSource = () => {

  const ctx = useTableContext()

  const { sortModel: [sort], page, pageSize, reload } = ctx.data.state
  const { value: search } = ctx.search.state
  const { values: filters } = ctx.filters.state

  useEffect(() => {

    if (ctx.lifecycle.state < LifecycleState.Ready) return

    const args: IFetchArgs = {
      page,
      pageSize,
      search: search || undefined,
      filters: mapFiltersData(filters),
      sort: sort && `${sort.field} ${sort.sort}` || undefined,
    }

    ctx.props.onFetchRequested(args)
  }, [search, filters, sort, pageSize, page, reload])

  return {
      // rowsMemo,
  }
}
